export const isOdd = (number: number): boolean => number % 2 !== 0

export const moreThanOne = (number: number): boolean => number >= 2
